var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], { autoescape: true });
} else {
	env = nunjucks.currentEnv;
}
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});




var shim = require("/Users/aaronphy/gitlab/lazada/node_modules/_nunjucks-loader@2.4.8@nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["src/component/baseui/templates/slideup.html"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
output += "<div class=\"m-card-popup m-card-popup-";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "name"), env.opts.autoescape);
output += "\">\n    <div class=\"popup-mask J_Mask\" role=\"button\" aria-label=\"点击关闭浮层\"></div>\n    <div class=\"popup-list slideUp slide-in-from-bottom\">\n        <div class=\"toggle J_Toggle\" role=\"button\" aria-label=\"点击关闭浮层\">\n            <i class=\"toggle-icon\" aria-hidden=\"true\"></i>\n        </div>\n         <div class=\"list-wrapper\">\n           ";
output += runtime.suppressValue(env.getFilter("safe").call(context, runtime.contextOrFrameLookup(context, frame, "content")), env.opts.autoescape);
output += "\n        </div>\n    </div>\n</div>";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["src/component/baseui/templates/slideup.html"] , dependencies)


//////////////////
// WEBPACK FOOTER
// ./src/component/baseui/templates/slideup.html
// module id = 151
// module chunks = 0 1